import { gql } from 'graphql-request'

export const setPharmacyProjectStatus = gql`
  mutation($pharmacyId: ID!, $projectId: ID!, $statusId: ID) {
    setPharmacyProjectStatus(pharmacyId: $pharmacyId, projectId: $projectId, statusId: $statusId) {
      status_id
    }
  }
`
